import { Box, CircularProgress } from "@mui/material";
import { useEntityAddress } from "../../../hooks/Entity";
import EntityAddresses from "../../Entities/Addresses/EntityAddresses";

interface AddressesTabProps {
  entityId?: string;
  entityName?: string;
  handleError?: (err: any) => void;
}

const AddressesTab: React.FC<AddressesTabProps> = ({ entityId, entityName, handleError }) => {
  const { addressesData, isPending, createAddress, updateAddress, deleteAddress, setPrimaryAddress } = useEntityAddress(entityId);

  if (isPending && addressesData.length === 0)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );

  return (
    <EntityAddresses
      entityId={Number(entityId)}
      entityName={entityName ?? ""}
      addressesData={addressesData}
      onCreate={async (values) => {
        await createAddress(values).catch(handleError)
      }}
      onUpdate={async (id, values) => {
        await updateAddress({ addressId: id, values }).catch(handleError)
      }}
      onDelete={async (id) => {
        await deleteAddress(id).catch(handleError)
      }}
      onSetPrimary={async (id) => {
        await setPrimaryAddress(id).catch(handleError)
      }}
    />
  );
};

export default AddressesTab;